import { render, staticRenderFns } from "./SystemHistory.vue?vue&type=template&id=186375ae"
import script from "./SystemHistory.vue?vue&type=script&lang=js"
export * from "./SystemHistory.vue?vue&type=script&lang=js"
import style0 from "./SystemHistory.vue?vue&type=style&index=0&id=186375ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports